import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { LayoutService } from '../services/layout.service';

@Pipe({
    name: 'mediaQuery',
    pure: false,
})
export class MediaQueryPipe implements PipeTransform, OnDestroy {
    private mediaQueries;

    private onMediaChange = () => {
        this.cdr.markForCheck();
    };

    constructor(
        layout: LayoutService,
        private cdr: ChangeDetectorRef,
    ) {
        this.mediaQueries = layout.getMediaQueries();
        this.mediaQueries.desktop.addEventListener('change', this.onMediaChange);
        this.mediaQueries.tablet.addEventListener('change', this.onMediaChange);
        this.mediaQueries.laptop.addEventListener('change', this.onMediaChange);
    }

    /**
     * Returns `true` if the current document size is smaller then the critera for the given media type. \
     * \
     * `'mobile'` - screen size is less than 768px \
     * `'tablet'` - screen size is less than 992px \
     * `'laptop'` - screen size is less than 1440px \
     * `'desktop'` - screen size is greathen than 1440px
     *
     * @param query the media type to check size for.
     * @returns `true` if the given media type critera matched the current document size, `false` if not.
     */
    transform(query: ('mobile' | 'tablet' | 'laptop' | 'desktop')[] | ('mobile' | 'tablet' | 'laptop' | 'desktop')): boolean {
        const { desktop, tablet, laptop } = this.mediaQueries;

        let matches = false;

        if (query === 'mobile' || (Array.isArray(query) && query.includes('mobile'))) {
            matches = tablet.matches === false && laptop.matches === false && desktop.matches === false;
        }
        if ((query === 'tablet' || (Array.isArray(query) && query.includes('tablet'))) && !matches) {
            matches = tablet.matches === true && laptop.matches === false && desktop.matches === false;
        }
        if ((query === 'laptop' || (Array.isArray(query) && query.includes('laptop'))) && !matches) {
            matches = tablet.matches === true && laptop.matches === true && desktop.matches === false;
        }
        if ((query === 'desktop' || (Array.isArray(query) && query.includes('desktop'))) && !matches) {
            matches = tablet.matches === true && laptop.matches === true && desktop.matches === true;
        }

        return matches;
    }

    ngOnDestroy(): void {
        this.mediaQueries.desktop.removeEventListener('change', this.onMediaChange);
        this.mediaQueries.tablet.removeEventListener('change', this.onMediaChange);
        this.mediaQueries.laptop.removeEventListener('change', this.onMediaChange);
    }
}
